import { render, staticRenderFns } from "./poster_connect.vue?vue&type=template&id=2df20a29&scoped=true&"
import script from "./poster_connect.vue?vue&type=script&lang=js&"
export * from "./poster_connect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df20a29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df20a29')) {
      api.createRecord('2df20a29', component.options)
    } else {
      api.reload('2df20a29', component.options)
    }
    module.hot.accept("./poster_connect.vue?vue&type=template&id=2df20a29&scoped=true&", function () {
      api.rerender('2df20a29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/poster/poster_connect.vue"
export default component.exports